import React, { useRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import RepairSlider from "./RepairSlider";
import styles from "./RepairService.module.scss";

interface RepairServiceProps {
  translationKey?: string;
  images?: string[];
}

const RepairService: React.FC<RepairServiceProps> = ({
  translationKey = "repairService",
  images,
}) => {
  const { t } = useTranslation("common");
  const stepsRef = useRef<HTMLDivElement>(null);
  const [stepsHeight, setStepsHeight] = useState<number | undefined>(undefined);

  useEffect(() => {
    const el = stepsRef.current;
    if (!el) return;
    const ro = new ResizeObserver(() => {
      setStepsHeight(el.offsetHeight);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  const steps = t(`${translationKey}.steps`, { returnObjects: true }) as Array<{
    number: string;
    title: string;
    description: string;
  }>;

  return (
    <div className="container section">
      <div
        className={`${styles.repairService} sectionContainer sectionContainerWhite bigSection`}
      >
        <div className={`sideP64 titleCont ${styles.mainReviewBlock}`}>
          <div className="titleBlock">
            <h2>{t(`${translationKey}.title`)}</h2>
          </div>
        </div>
        <div className={`${styles.repairServiceContainer} sideP64`}>
          <div className={styles.stepsContainer} ref={stepsRef}>
            {steps.map((step, index) => (
              <div key={step.number} className={styles.step}>
                <div className={styles.stepNumber}>{step.number}</div>
                <div className={styles.pointBlock}>
                  <div className={styles.point}></div>
                </div>
                {index < steps.length - 1 && (
                  <div className={styles.stepline}></div>
                )}
                <div className={styles.stepContent}>
                  <h2 className={styles.stepTitle}>{step.title}</h2>
                  <p className={styles.stepText}>{step.description}</p>
                </div>
              </div>
            ))}
          </div>

          {images && images.length > 1 ? (
            <div className={styles.sliderWrapper}>
              <RepairSlider
                images={images}
                alt={t(`${translationKey}.imageAlt`)}
                maxHeight={stepsHeight}
              />
            </div>
          ) : (
            <div className={styles.imgWrapper}>
              <img
                src={images?.[0] || "/images/werkstatt-berlin-delivery.webp"}
                alt={t(`${translationKey}.imageAlt`)}
                className={styles.headerImage}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RepairService;
